var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenInNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.788 13.8892H4.55382V3.65502H9.67091V2.19299H4.55382C3.7424 2.19299 3.0918 2.8509 3.0918 3.65502V13.8892C3.0918 14.6933 3.7424 15.3512 4.55382 15.3512H14.788C15.5921 15.3512 16.25 14.6933 16.25 13.8892V8.77211H14.788V13.8892ZM11.1329 2.19299V3.65502H13.7573L6.57142 10.8409L7.60214 11.8716L14.788 4.68575V7.31008H16.25V2.19299H11.1329Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenInNew);
export default __webpack_public_path__ + "static/media/open_in_new.a73d555ed97ef2a82a6718ec9bd2ba31.svg";
export { ForwardRef as ReactComponent };